var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-dropbox text-light",class:[
    { show: !_vm.isHidden, 'position-fixed': _vm.isFixed },
    _vm.positionClass,
    ("regard-" + _vm.regard),
    _vm.custom,
    _vm.nofix ],style:(_vm.calculatePosition)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }